export default __webpack_public_path__ + "static/media/20-3.ce2bab12.mp3";